define('lq/events/actions/share',[
    'lq/events/actions/eventAction',
    'lq'
], function(EventAction, lq) {
    'use strict';

    function Share(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        this.eventData = eventData;
        return this;
    }

    EventAction.extend(Share, EventAction);

    Share.typeName = 'Share';

    Share.prototype.getBatchType = function() {
        return EventAction.DO_NOT_BATCH;
    };

    Share.prototype.execute = function(continuation) {
        const title = this.piping.parameters.replace(this.eventData.title);
        var shareData = {
            title: title
        };
        if (this.eventData.shareType === 'Text') {
            shareData.text = this.piping.parameters.replace(this.eventData.textToShare);
            navigator.share(shareData)
                .then(function () {
                    continuation();
                })
                .catch(function (e) {
                    continuation();
                });
        } else {
            if (this.eventData.sourceFileDataSource && this.eventData.sourceFileOutput) {
                var queryString = {
                    actionId: this.piping.actionId,
                    commandId: this.eventData.command,
                    parameters: JSON.stringify(this.piping.parameters.getNonSystemParameters())
                };
                var self = this;
                var downloadUrl = this.piping.url.prepare(lq.getTenantUrl('Export/Share'), queryString);
                fetch(downloadUrl).then(function (response) {
                    response.blob().then(function (data) {
                        var metadata = {
                            type: response.headers.get('content-type')
                        };
                        var fileName = self.piping.parameters.replace(self.eventData.fileName);
                        if (!fileName) {
                            // Get the fileName from: 'attachment; filename=nameOfTheFile.svg'
                            var disposition = response.headers.get('content-disposition');
                            if (disposition && disposition.indexOf('attachment') !== -1) {
                                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                                var matches = filenameRegex.exec(disposition);
                                if (matches != null && matches[1]) {
                                    fileName = matches[1].replace(/['"]/g, '');
                                }
                            }
                        }
                        var file = new File([data], fileName, metadata);
                        shareData.files = [file];
                        if (navigator.canShare(shareData)) {
                            navigator.share(shareData)
                                .then(function () {
                                    continuation();
                                })
                                .catch(function (e) {
                                    continuation();
                                });
                        } else {
                            continuation();
                        }
                    });
                });
            } else {
                continuation();
            }
        }
    };

    return Share;
});

